var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('menu-drop-down',{ref:"menu",attrs:{"disabled":_vm.disabled,"menu":_vm.menu}}),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","id":"file","title":""},on:{"change":_vm.handleFileUpload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }